<div style="color: white; font-size: 12pt; height: 100%; width: 100%; overflow: auto;">
    <!-- Copy Button -->
    <button mat-icon-button (click)="Export()" matTooltip="Export" style="position: absolute; top: 10px; right: 10px; z-index: 10;">
        <mat-icon color="primary">file_download</mat-icon>
    </button>
    <button mat-icon-button (click)="copyJson()" matTooltip="Copy Config" style="position: absolute; top: 10px; right: 40px; z-index: 10;">
        <img src="assets/images/Copy JSON Button.png"
            alt="Copy Config"
            style="width: 24px; height: 24px;" />
    </button>

    <!-- <button
        mat-icon-button
        color="primary"
        (click)="copyJson()"
        matTooltip="Copy JSON"
        style="position: absolute; top: 10px; right: 10px; z-index: 10;">
        <mat-icon>content_copy</mat-icon>
    </button> -->
    <!-- JSON Viewer -->
    <pre>
        {{json}}
    </pre>
</div>